import { render, staticRenderFns } from "./EffectiveAbandonFilter.vue?vue&type=template&id=995e773e&"
import script from "./EffectiveAbandonFilter.vue?vue&type=script&lang=js&"
export * from "./EffectiveAbandonFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports